import { query_order_used_cancel_record_list } from '@/api/mjstore-model';
import { reactive } from 'vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import defaultSlotList from '@/components/page-model/slotList';
import { TableColumn } from '@/typing';
import { SearchConfig } from '@/components/FormRender/RemoteModal/typing';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const config: SearchConfig = {
  settings: {
    name: '表单名称',
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'remotemodal',
      name: 'customer_id',
      label: '会员姓名',
      disabled: false,
      placeholder: '请选择会员姓名',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-customer',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    customer_id: null,
  }),
};
const search_options = {};

const columns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: 'ID',
    width: 150,
    dataIndex: 'id',
    fixed: false,
    checked: false,
  },
  {
    title: '耗单号',
    width: 150,
    dataIndex: 'order_code',
    fixed: false,
    checked: true,
  },
  {
    title: '关联耗单',
    width: 150,
    dataIndex: 'order_used_record_id',
    fixed: false,
    checked: true,
  },
  {
    title: '客户ID',
    width: 150,
    dataIndex: 'customer_id',
    fixed: false,
    checked: false,
  },
  {
    title: '客户编号',
    width: 150,
    dataIndex: 'customer__code',
    fixed: false,
    checked: true,
  },
  {
    title: '会员姓名',
    width: 150,
    dataIndex: 'customer__name',
    fixed: false,
    checked: true,
  },
  {
    title: '退单次数',
    width: 150,
    dataIndex: 'num',
    fixed: false,
    checked: true,
  },
  {
    title: '卡转单卡点数',
    width: 150,
    dataIndex: 'card_num',
    fixed: false,
    checked: true,
  },
  {
    title: '总价',
    width: 150,
    dataIndex: 'price',
    fixed: false,
    checked: true,
  },
  {
    title: '单价',
    width: 150,
    dataIndex: 'single_price',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '换单价差',
    width: 150,
    dataIndex: 'diff_price',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '充值使用金额',
    width: 150,
    dataIndex: 'czje',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '返利使用金额',
    width: 150,
    dataIndex: 'flje',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '直接返利',
    width: 150,
    dataIndex: 'zjfl',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '赠券使用金额',
    width: 150,
    dataIndex: 'zjje',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '退货日期',
    width: 150,
    dataIndex: 'date',
    fixed: false,
    checked: true,
  },
  {
    title: '员工编码',
    width: 150,
    dataIndex: 'staff__code',
    fixed: false,
    checked: true,
  },
  {
    title: '员工姓名',
    width: 150,
    dataIndex: 'staff__name',
    fixed: false,
    checked: true,
  },
  {
    title: '执行人',
    width: 150,
    dataIndex: 'staff_id',
    fixed: false,
    checked: true,
  },
  {
    title: '备注',
    width: 150,
    dataIndex: 'mark',
    fixed: false,
    checked: true,
  },
  {
    title: '所属顾问',
    width: 150,
    dataIndex: 'customer__adviser__name',
    checked: true,
  },
  {
    title: '执行门店',
    width: 150,
    dataIndex: 'shop_id',
    fixed: false,
    checked: true,
  },
  {
    title: '门店名称',
    width: 150,
    dataIndex: 'shop__name',
    fixed: false,
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    fixed: false,
    checked: true,
  },
  {
    title: '更新时间',
    width: 150,
    dataIndex: 'update_time',
    fixed: false,
    checked: true,
  },
  {
    title: '是否可用',
    width: 150,
    dataIndex: 'is_active',
    fixed: false,
    checked: true,
  },
];

export default () => {
  return {
    searchConfig: config,
    searchConfigOptions: search_options,
    getData: query_order_used_cancel_record_list,
    columns: columns,
    slotList: defaultSlotList,
  };
};
